module.exports = __webpack_public_path__ + "static/assets/89759cd558cd65f44286f3a21eb069df.svg";